import isFunction from 'lodash/isFunction';
import noop from 'lodash/noop';
import moment from 'moment/moment';
import {RequestStatus} from '../enums/RequestStatus';


export const BASE_OPTIONS = {
  modalCloseDelay: 2000,
  getParams: noop,
  getResponseStatus,
  buildRequest: defaultBuildRequest,
};

function defaultBuildRequest() {
  return {};
}

export const BASE_MODAL_CONFIG = {
  useListStateFilter: true,
};

function getResponseStatus(request, response) {
  if (response.status === 200 && response.response) {
    return RequestStatus.SUCCESS;
  } else {
    return RequestStatus.NO_RESULTS;
  }
}

/**
 * @param {ReduxObservableListExportsOptions} options
 */
export function validateOptions(options) {
  if (!isFunction(options.getReportState)) {
    throw new Error('ReduxListExports missing required getReportState');
  }

  if (!options.modalComponent) {
    throw new Error('ReduxListExports missing required modalComponent');
  }
}

/**
 * @param {ExportModalHOCOptions} options
 */
export function validateModalConfig(options) {
  if (options.useListStateFilter && !isFunction(options.getState)) {
    throw new Error('ReduxListExports missing required getState');
  }

  if (!isFunction(options.getReportState)) {
    throw new Error('ReduxListExports exportConfig missing required getReportState');
  }

  if (!options.useListStateFilter && !isFunction(options.getDefaultFilterData)) {
    throw new Error('ReduxListExports exportConfig missing required getDefaultFilterData');
  }
}

export function hackFixDSTExcelDates(dateHeaders) {
  return ajaxResponse => {
    const tz = moment.tz.guess();
    const offset = moment().format("Z");

    ajaxResponse.response.list.forEach(item =>
      dateHeaders.forEach(header => {
        if (item[header]) {
          // DST Timezone hack. Force the dates to be rendered in the local timezone so that dates at midnight should render correctly in excel
          const m = moment.tz(item[header], tz);
          item[header] = new Date(m.format("YYYY-MM-DDTHH:mm:ss") + offset);
        }
      }));
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-observable-list-exports/utils.js